
/// <reference path="../../../../typings/tsd.d.ts" />
module warsApp.controllers {
    export interface IFormConfigurationScope extends angular.IScope {
        model: models.FormConfigurationModel
    }

    export class FormConfigurationController implements IController {
        constructor(
            private scope: IFormConfigurationScope,
            formService: services.FormService,
            $routeParams: angular.route.IRouteParamsService,
            modalService: any,
            growl: angular.growl.IGrowlService,
            $http: ng.IHttpService, contentPageService: services.ContentPageService,
            formSectionService: services.FormSectionService,
            dataSourceService: services.DataSourceService,
            $q: angular.IQService,
            processConfigurationService:services.ProcessConfigurationService) {

            var processId = $routeParams["id"];
            var formId = $routeParams["subId"];

            this.scope.model = new models.FormConfigurationModel(
                formId,
                processId,
                formService,
                modalService,
                growl,
                $http,
                contentPageService,
                formSectionService,
                scope,
                dataSourceService,
                $q,
                processConfigurationService);
        }
    }
}

warsApp.registerController('FormConfigurationController', ['$scope', 'formService',
    '$routeParams', 'ModalService', 'growl', '$http', 'contentPageService', 'formSectionService', 'dataSourceService','$q','processConfigurationService']);
